const SESSION_KEY = 'cnxion_event_history';

function isSessionStorageAvailable(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const testKey = '__session_test__';
    sessionStorage.setItem(testKey, 'test');
    sessionStorage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}

export function getSessionHistory(): string[] {
  if (!isSessionStorageAvailable()) return [];
  try {
    const stored = sessionStorage.getItem(SESSION_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function addToSessionHistory(eventName: string): void {
  if (!isSessionStorageAvailable()) return;
  try {
    const history = getSessionHistory();
    if (!history.includes(eventName)) {
      history.push(eventName);
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(history));
    }
  } catch {
    // Silently fail if storage is blocked
  }
}

export function sessionHasEvent(eventName: string): boolean {
  return getSessionHistory().includes(eventName);
}

export function sessionHasAnyOf(events: string[]): boolean {
  const history = getSessionHistory();
  return events.some((event) => history.includes(event));
}
